import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CabeceraVAMModule } from "../../../components/common/cabeceraVAMTitulares/cabecera-vam-titulares.module";
import { vamTitulares } from "./vam-titulares.component";
import { VamTitularesService } from "./vam-titulares.service";
import { vamImpuestoRenta } from "./vam-impuestoRenta.component";
import { VamTrackingComponent } from "./vam-tracking.component";
import { FilterDocumentoVamTitulares } from "./vam-titulares.pipe";

@NgModule({
    declarations: [vamTitulares, vamImpuestoRenta, FilterDocumentoVamTitulares],
    imports: [BrowserModule, HttpModule,
        FormsModule,
        BrowserAnimationsModule,
        CabeceraVAMModule],
    providers: [VamTitularesService]
})

export class VamTitularesModule { }




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/titulares/vam-titulares.module.ts